export const SIGN_INVOICE_BY_EXECUTOR = 'SIGN_INVOICE_BY_EXECUTOR'
export const SIGN_INVOICE_BY_CUSTOMER = 'SIGN_INVOICE_BY_CUSTOMER'
export const SIGN_RETURN_INVOICE_BY_EXECUTOR = 'SIGN_RETURN_INVOICE_BY_EXECUTOR'
export const SIGN_RETURN_INVOICE_BY_CUSTOMER = 'SIGN_RETURN_INVOICE_BY_CUSTOMER'